<template>
  <section :class="$style['problems-items']">
    <problems-item
      v-for="(item, index) in items"
      :key="index"
      :number="index + 1"
      :headline="item.headline"
      :paragraphs="item.paragraphs"
    />
  </section>
</template>

<script>
import ProblemsItem from './ProblemsItem.vue';

export default {
  components: {
    ProblemsItem,
  },
  data() {
    return {
      items: [
        {
          headline: this.$t('problems.item-1.headline'),
          paragraphs: [this.$t('problems.item-1.paragraph')],
        },
        {
          headline: this.$t('problems.item-2.headline'),
          paragraphs: [this.$t('problems.item-2.paragraph')],
        },
        {
          headline: this.$t('problems.item-3.headline'),
          paragraphs: [
            this.$t('problems.item-3.paragraph-1', {
              class: this.$style['problems-items-paragraph-company'],
            }),
            this.$t('problems.item-3.paragraph-2'),
          ],
        },
        {
          headline: this.$t('problems.item-4.headline'),
          paragraphs: [
            this.$t('problems.item-4.paragraph-1'),
            this.$t('problems.item-4.paragraph-2'),
          ],
        },
        {
          headline: this.$t('problems.item-5.headline'),
          paragraphs: [
            this.$t('problems.item-5.paragraph-1'),
            this.$t('problems.item-5.paragraph-2'),
          ],
        },
        {
          headline: this.$t('problems.item-6.headline'),
          paragraphs: [
            this.$t('problems.item-6.paragraph-1'),
            this.$t('problems.item-6.paragraph-2'),
            this.$t('problems.item-6.paragraph-3'),
          ],
        },
        {
          headline: this.$t('problems.item-7.headline'),
          paragraphs: [this.$t('problems.item-7.paragraph')],
        },
      ],
    };
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.problems-items {
  max-width: $page-laptop-breakpoint;
  margin-bottom: 80px;
  display: flex;
  flex-wrap: wrap;
}

.problems-items-paragraph-company {
  color: $blue;
}

@media (max-width: $page-table-breakpoint) {
  .problems-items {
    justify-content: center;
  }
}
</style>
